import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';

export const networkCreateApplicationMenu = async (data) => {
  const res = await axiosInstance.post('ApplicationMenu/Insert', data);
  return res;
};

export const networkUpdateApplicationMenu = async (id, data) => {
  const res = await axiosInstance.post(`ApplicationMenu/Update/${id}`, data);
  return res;
};

export const networkRemoveApplicationMenu = async (id) => {
  const res = await axiosInstance.post(`ApplicationMenu/Remove/${id}`);
  return res;
};

export const networkGetApplicationMenuList = async (data, pageIndex = 0, pageSize = 100) => {
  const res = await axiosInstance.post(`ApplicationMenu/List/${pageIndex}/${pageSize}`, data);
  return res;
};

export function useFetchApplicationMenuList(data, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['application-menu-items', data,pageIndex],
    queryFn: () => networkGetApplicationMenuList(data, pageIndex, pageSize),
  });
}
